export default defineNuxtPlugin(() => {
  const pathNames: Record<string, string> = {
    dashboard: 'Dashboard',
    vps: 'Virtual Private Servers',
    auth: 'Authentication',
    login: 'Login',
    register: 'Register',
  };

  interface Breadcrumb {
    title: string;
    disabled: boolean;
    href: string;
  }

  const generateBreadcrumbs = (): Breadcrumb[] => {
    if (typeof window === 'undefined') return [];

    const currentPath: string = window.location.pathname;
    const paths: string[] = currentPath.split('/').filter((path) => path !== '');
    const breadcrumbs: Breadcrumb[] = [];

    let pathAccumulator = '';
    paths.forEach((path, index) => {
      const displayName: string = pathNames[path] || path.charAt(0).toUpperCase() + path.slice(1);
      pathAccumulator += `/${path}`;

      breadcrumbs.push({
        title: displayName,
        disabled: index !== paths.length - 1, // Disable all but the last breadcrumb
        href: pathAccumulator,
      });
    });

    return breadcrumbs;
  };

  return {
    provide: {
      breadcrumbs: generateBreadcrumbs,
    },
  };
});
